import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <header>
        <Navbar />
      </header>

      <main className="flex-grow">
        {children || <Outlet />}
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default Layout;